class KailarNewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.form = this.querySelector('[data-newsletter-popup-form]');
    this.status = this.querySelector('[data-newsletter-popup-status]');
    this.closeButton = this.querySelector('[data-newsletter-popup-close]');
    this.dismissButton = this.querySelector('[data-newsletter-popup-dismiss]');
    this.launcher = this.querySelector('[data-newsletter-popup-launcher]');
    this.openButton = this.querySelector('[data-newsletter-popup-open]');
    this.hideLauncherButton = this.querySelector('[data-newsletter-popup-hide-launcher]');
    this.storageKey = this.dataset.storageKey || 'kailar-newsletter-popup-v1';
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!this.dialog || !this.form || !this.launcher) return;

    this.openButton?.addEventListener('click', () => this.open());
    this.hideLauncherButton?.addEventListener('click', () => this.hideLauncherForSession());
    this.closeButton?.addEventListener('click', () => this.close('close'));
    this.dismissButton?.addEventListener('click', () => this.close('dismiss'));
    // No submit handler here on purpose: kailar-klaviyo-subscribe.js listens on
    // document and owns validation, the request and the status message. A second
    // handler would either fire a duplicate signup or overwrite its message.
    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close('escape');
    });
    this.dialog.addEventListener('click', (event) => this.handleBackdropClick(event));

    const params = new URLSearchParams(window.location.search);
    const forcePreview = params.get('kailar_newsletter_popup') === '1';

    const launcherDismissed = this.getLauncherDismissal();

    this.launcher.hidden = launcherDismissed && !forcePreview;
    this.classList.add('is-ready');

    if (forcePreview) window.queueMicrotask(() => this.open());
  }

  getLauncherDismissal() {
    try {
      return window.sessionStorage.getItem(`${this.storageKey}-launcher`) === 'hidden';
    } catch (_error) {
      return false;
    }
  }

  hideLauncherForSession() {
    try {
      window.sessionStorage.setItem(`${this.storageKey}-launcher`, 'hidden');
    } catch (_error) {
      // Storage may be unavailable in privacy-restricted browsing contexts.
    }

    this.launcher.hidden = true;
    document.querySelector('#MainContent')?.focus({ preventScroll: true });
  }

  open() {
    if (this.dialog.open) return;

    this.previousFocus = document.activeElement;
    document.body.classList.add('kailar-newsletter-popup-open');
    this.dialog.showModal();

    window.requestAnimationFrame(() => {
      this.dialog.classList.add('is-visible');
      this.dialog.focus({ preventScroll: true });
    });
  }

  close(reason) {
    if (!this.dialog.open) return;

    this.dialog.classList.remove('is-visible');

    const finish = () => {
      if (this.dialog.open) this.dialog.close(reason);
      document.body.classList.remove('kailar-newsletter-popup-open');

      if (this.previousFocus instanceof HTMLElement) {
        this.previousFocus.focus({ preventScroll: true });
      }
    };

    if (this.reducedMotion.matches) {
      finish();
    } else {
      window.setTimeout(finish, 180);
    }
  }

  handleBackdropClick(event) {
    if (event.target !== this.dialog) return;

    const bounds = this.dialog.getBoundingClientRect();
    const inside = event.clientX >= bounds.left && event.clientX <= bounds.right
      && event.clientY >= bounds.top && event.clientY <= bounds.bottom;

    if (!inside) this.close('backdrop');
  }
}

if (!customElements.get('kailar-newsletter-popup')) {
  customElements.define('kailar-newsletter-popup', KailarNewsletterPopup);
}
